// extracted by mini-css-extract-plugin
export default {"table":"table_table__H5qvx","tableStickyHead":"table_tableStickyHead__l8Obj","sortIcons":"table_sortIcons__6hRvf"};